module.exports = __webpack_public_path__ + "static/media/collectiveFarming.528706b6.jpeg";